import { Component, OnInit } from '@angular/core';
import { BlogService } from '../services/blog.service';
import { BlogList, BlogCount } from '../blog-interface';
import { DataService } from '../../services/data.service';
import { environment } from '../../../environments/environment.prod';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FlashService } from '../../flash/flash.service';

@Component({
  selector: 'app-user-list-blog',
  templateUrl: './user-list-blog.component.html',
  styleUrls: ['./user-list-blog.component.css']
})
export class UserListBlogComponent implements OnInit {

  blogList: BlogList[];
  blogCount;
  filterForm: FormGroup;
  currentPageNo = 1;
  submission_date;
  start_date;
  end_date;
  limit;
  sortBy = '';
  orderBy = '';
  type = '';
  total;
  perpage;
  default = [
    {
      'key': 'Yearly',
      'value': 'Yearly (April-March)',
      'start_date': '2020-04-01',
      'end_date': '2021-03-30'
    }
  ]
  types = [
    {
      'value': 'all',
      'label': 'All'
    },
    {
      'value': 'submission_date',
      'label': 'Submission Date'
    },
    {
      'value': 'published_date',
      'label': 'Published Date'
    }
  ]
  times = environment.Quarters;
  todayDate;
  startYear;
  endYear;
  sDate;
  eDate;
  date1;
  date2;
  noData: boolean;
  constructor(
    public blogService: BlogService,
    public dataService: DataService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    public flashService: FlashService
  ) {
    this.todayDate = new Date();
    const presentDate = this.stringToDate(this.todayDate);
    if (presentDate.date.month >= 4) {
      this.startYear = presentDate.date.year;
      this.endYear = presentDate.date.year + 1;
    }
    else {
      this.startYear = presentDate.date.year - 1;
      this.endYear = presentDate.date.year;
    }
    this.filterForm = this.formBuilder.group({
      quarter: new FormControl('Yearly', Validators.required),
      type: new FormControl('all', Validators.required)
    });
  }

  ngOnInit() {
    this.getBlogList();
  }
  stringToDate(value) {
    const dateObject = {
      date: {
        year: value.getFullYear(),
        month: (value.getMonth() + 1),
        day: (value.getDate())
      }
    };
    return dateObject;
  }
  dateToString(value) {
    const dateString = value.date.year + '-' +
      (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
      (value.date.day < 10 ? '0' : '') + value.date.day;
    return dateString;
  }
  changeType(value) {
    if (value === 'submission_date') {
      this.type = value;
    }
    else {
      this.type = value;
    }
  }
  changeTime(value) {
    this.default.forEach(data => {
      if (value == data.key) {
        this.date1 = data.start_date;
        this.date2 = data.end_date;
      }
    })
    this.times.forEach(data => {
      if (value == data.key) {
        this.date1 = data.start_date;
        this.date2 = data.end_date;
      }
    })
    this.start_date = this.stringToDate(new Date(this.date1))
    this.end_date = this.stringToDate(new Date(this.date2))
    if (value === "Yearly") {
      this.start_date.date.year = this.startYear;
      this.end_date.date.year = this.endYear;
    } else if ((this.start_date && this.start_date.date.month >= 4) && (this.end_date && this.end_date.date.month >= 4)) {
      this.start_date.date.year = this.startYear;
      this.end_date.date.year = this.startYear;
    } else {
      this.start_date.date.year = this.endYear;
      this.end_date.date.year = this.endYear;
    }
    this.start_date = this.dateToString(this.start_date);
    this.end_date = this.dateToString(this.end_date)
  }
  goToUrl(url) {
    if (url != "") {
      window.open(url);
    }
    else {
      this.flashService.show('Please update blog url for further action', 'alert-danger')
    }
  }
  onSubmit(formData) {
    this.changeTime(formData.value.quarter);
    this.getBlogList();
  }
  getBlogList(pgNo?) {
    this.spinnerService.show();
    if (pgNo != null) {
      this.currentPageNo = pgNo;
    }
    this.limit = 15;
    this.blogService.getUserBlogList(this.start_date, this.end_date, this.type, this.currentPageNo,
      this.limit, this.orderBy, this.sortBy).subscribe(data => {
        this.spinnerService.hide();
        this.total = data['totalcount'];
        this.perpage = data['perpage'];
        this.blogList = data['blog_list'];
        if (this.blogList.length == 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      })
    this.blogService.getBlogCount(this.start_date, this.end_date, this.type).subscribe(data => {
      this.blogCount = data['counts'];

    });
  }
  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/blog/user-list-blog/user-list-blog.component.ts